export const palette = {
  primaryColor: "#791169",
  white: "#ffffff",
  black: "#000000",
  link: '#0000EE'
};
